// react
import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';

// components
import { Helmet } from 'react-helmet-async';
import Header from 'layout/MainLayout/Header';
import AspTags from 'asp/rental';

const MainLayout = () => {
  // const { pathname } = useLocation();
  // const path = pathname.split('/');
  // const isCart = ['', 'form', 'confirm', 'complete'].includes(path[1]);
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <Helmet>
        <script src={`${process.env.REACT_APP_GMO_MP_ENDPOINT}/payment/js/mp-token.js`}></script>
      </Helmet>
      <Header />
      <Outlet />
      <AspTags />
    </Suspense>
  );
};

export default MainLayout;
